
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/how-to-ask-better-legal-questions",
      function () {
        return require("private-next-pages/learn/how-to-ask-better-legal-questions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/how-to-ask-better-legal-questions"])
      });
    }
  